export default function langReducer(state =[], action){
    switch (action.type){
        case "TOGGLE_LANGUAGE":
            return action.language;
        default:
            return state;
    }
}